import WalmartLogo from '../assets/imgs/ourClients/Walmart.png'
import NSFLogo from '../assets/imgs/ourClients/NSF.png'
import DODLogo from '../assets/imgs/ourClients/DoD.png'
import DoSLogo from '../assets/imgs/ourClients/DoS.png'
import PAMLogo from '../assets/imgs/ourClients/PAM.png'
import CSCLogo from '../assets/imgs/ourClients/CSC.png'

export const OUR_CLIENTS_IMAGES = [
  {
    src: WalmartLogo,
    alt: "Walmart's logo",
  },
  {
    src: NSFLogo,
    alt: "National Science Foundation's logo",
  },
  {
    src: DODLogo,
    alt: 'U.S. Department of Defense logo',
  },
  {
    src: DoSLogo,
    alt: "Department of State's logo",
  },
  {
    src: PAMLogo,
    alt: "PAM Health's logo",
  },
  {
    src: CSCLogo,
    alt: "Colby Sawyer College's logo",
  },
]

export const SWIPE_THRESHOLD = 60
